export default "__VITE_ASSET__DfIprGnF__"